export default {
    add_all_materials_from_warehouse: "Қоймадағы барлық материалдарды қосу",
    add_good: "Өнім қосыңыз",
    add_material: "Материал қосу",
    add_new: "Жаңасын қосу",
    adding_new_supplier: "Жаңа жеткізушіні қосу",
    addition: "Кіріс",
    address: "Мекенжайы",
    adjustment: "Түзету",
    amount: "Саны",
    amount_of_stock_on_all_warehouses: "Клиниканың барлық қоймаларында қолжетімді тауарлардың жалпы саны",
    approve: "Өткізу",
    approved: "Өткізілді",
    are_you_sure_you_want_to_delete_group: "Топты жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_kit: "Жинақты жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_supplier: "Жеткізушіні жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_warehouse: "Қойманы жойғыңыз келе ме?",
    artikul: "Артикул",
    available_for_sale: "Сатуға болады",
    bank_requisites: "Банк деректемелері",
    barcode: "Штрихкод",
    beginning_balance: "Бастапқы қалдық",
    bin: "БСН",
    branch: "Филиал",
    bulk_addition: "Топпен қосу",
    by_categories: "Санаттар бойынша",
    consumption: "Шығыс",
    consumption_manual: "Қолмен шығыс",
    contact_person: "Байланысушы тұлға",
    contragent: "Контрагент",
    cost: "Құны",
    created: "Жасалды",
    current_stock: "Ағымдағы қалдық",
    default_for_sale: "Өнімдерді сату үшін әдепкі ретінде қолданыңыз",
    default_for_writeoff: "Материалдарды есептен шығару үшін әдепкі ретінде қолданыңыз",
    destination: "Тағайындалуы",
    details: "Мәліметтер",
    difference: "Айырмашылық",
    documents: "Құжаттар",
    draft: "Алғашқы түрі",
    enter_title_or_barcode: "Атауын немесе штрихкодты енгізіңіз",
    factual_amount: "Нақты саны",
    finished: "Өткізілді",
    finished2: "Аяқталды",
    found_similar_material: "Ұқсас материал табылды",
    from: "бастап",
    from_warehouse: "Қоймадан ауыстыру",
    from_where: "Қайдан",
    general_price: "Жалпы сома",
    general_stock: "Жалпы қалдық",
    group: "Топ",
    groups: "Топтар",
    id: "Id",
    in_warehouse: "Қоймада",
    inventarization: "Түгендеу",
    kit: "Жинақ",
    Kit: "Жинақ",
    kits: "Жинақтар",
    material: "Материал",
    materialgroup: "Топ",
    materials: "Материалдар",
    materialstock: "Материал",
    movement: "Жылжыту",
    movement_from: "Жылжыту",
    movement_to: "Жылжыту",
    movements: "Қозғалыстар",
    nomenclature: "Номенклатура",
    not_enough_material: "Материал жеткіліксіз",
    notify_when_stock: "қалдық кезінде хабарлау",
    on_visit_close: "Сапарды жабу кезінде",
    on_visit_save: "Сапарды сақтау кезінде",
    operation: "Операция",
    parent_category: "Ата-ана санаты",
    parent_group: " Ата-ана тобы",
    physical: "Табиғи",
    price_will_be_used_automatically_from_addition: "Баға түбіртек құжатынан автоматты түрде қолданылады",
    print: "Басып шығару",
    prohibit_minus_stocks: "Материалдарды алып тастауға тыйым салу",
    prohibit_minus_stocks_in_warehouse_documents: "Бұл параметр «Қойма» бөліміндегі құжаттарды толтыру кезінде материалдарды минус ретінде есептен шығаруға тыйым салады",
    prohibit_minus_stocks_on_visit_closing: "Бару материалдарын минус ретінде есептен шығаруға тыйым салу (баруды аяқтауға тыйым салу)",
    purchase_price: "Сатып алу бағасы",
    return: "Қайтару",
    returns: "Қайтарулар",
    sale_of_goods_refund: "Сатылған тауарларды қайтару",
    sale_price: "Сату бағасы",
    stocks: "Қалдықтар",
    stocks_archive: "Материалдар мұрағаты",
    supplier: "Жеткізуші",
    suppliers: "Жеткізушілер",
    to_warehouse: "Қоймаға жылжыту",
    to_where: "Қайда",
    trying_to_writeoff: "Есептен шығару әрекеті",
    type: "Түрі",
    unit_of_measure: "Өлшем бірлігі",
    virtual: "Виртуалды",
    warehouse_amount: "Қоймадағы саны",
    warehouseoperation: "Операциялар",
    warehouses: "Қоймалар",
    write_off: "Есептен шығару",
    write_off_materials: "Материалдарды есептен шығару"
}
